import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { MainWrapper, Center } from 'legacyComponents/styled/lib';
import {
  SideNavBarWrapper,
  SideNavBar,
  SideNavBarItem,
  SettingsWrapper,
  SideNavBarLink,
} from 'legacyComponents/sideNavBar';
import Spinner from 'components/Spinner';
import { routeNode, routerStore } from 'core/routing';

import { FourOhFour } from 'apps/fourOhFour';

// import { Home } from "apps/project/settings/tabs/home";
import { GeneralSettings } from 'apps/project/settings/tabs/general';
import { TeamSettings } from 'apps/project/settings/tabs/team';
import { AdminSettings } from 'apps/project/settings/tabs/admin';

import { ProjectSettingsAppManager } from 'apps/project/settings/appManager';
import { GroupsAppManager } from 'apps/group/appManager';

const viewsMap = {
  teams: TeamSettings,
  general: GeneralSettings,
  admin: AdminSettings,
};

@withNamespaces()
@inject('clientStore')
@observer
export class ProjectSettings extends React.Component {
  UNSAFE_componentWillMount() {
    this.manager = new ProjectSettingsAppManager(null, this.props);
    this.groupsManager = new GroupsAppManager(null, this.props);
  }

  render() {
    const View = this.props.componentFromRoute();
    const { clientStore, t } = this.props;
    const { loading, notFound, canUpdate } = this.manager;

    if (!loading && (notFound || (!canUpdate && !clientStore.isStaff))) {
      return <FourOhFour />;
    }

    const {
      route: { name },
      projectManager,
      repoManager,
      routerStore: { params },
    } = this.props;

    const profileName = params.get('profile');
    const initiativeName = params.get('initiative');
    const spaceType = profileName ? 'profile' : 'initiative';
    const spaceParams = {
      [spaceType]: profileName || initiativeName,
      slug: params.get('slug'),
    };

    if (this.groupsManager.loading) {
      return (
        <MainWrapper>
          <Center>
            <Spinner margin='70px' />
          </Center>
        </MainWrapper>
      );
    }

    if (projectManager && !this.groupsManager.loading) {
      return (
        <MainWrapper>
          <div className='inline-block w-full'>
            <SideNavBarWrapper>
              <SideNavBar style={{ marginTop: 6 }}>
                <SideNavBarItem isTitle>{t('Project Settings')}</SideNavBarItem>
                {canUpdate && (
                  <SideNavBarItem>
                    <SideNavBarLink
                      name={`${spaceType}.project.settings.teams`}
                      params={spaceParams}
                      active={name.includes('teams')}
                    >
                      {t('Collaborators')}
                    </SideNavBarLink>
                  </SideNavBarItem>
                )}
                {canUpdate && (
                  <SideNavBarItem last data-testid='setting-general-sideNavBar'>
                    <SideNavBarLink
                      name={`${spaceType}.project.settings.general`}
                      params={spaceParams}
                      active={name.includes('general')}
                    >
                      {t('General')}
                    </SideNavBarLink>
                  </SideNavBarItem>
                )}
                {clientStore.isStaff && (
                  <SideNavBarItem>
                    <SideNavBarLink
                      name={`${spaceType}.project.settings.admin`}
                      params={spaceParams}
                      active={name.includes('admin')}
                    >
                      {t('Admin tasks')}
                    </SideNavBarLink>
                  </SideNavBarItem>
                )}
              </SideNavBar>
            </SideNavBarWrapper>
            <SettingsWrapper style={{ marginTop: 12 }}>
              <View
                params={params}
                projectSettingsAppManager={this.manager}
                projectManager={projectManager}
                groupsManager={this.groupsManager}
                syncRepoAppManager={repoManager.syncRepoAppManager}
              />
            </SettingsWrapper>
          </div>
        </MainWrapper>
      );
    }
    return null;
  }
}

ProjectSettings.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
  projectManager: PropTypes.object,
  repoManager: PropTypes.object,
  clientStore: PropTypes.object,
};

@inject('clientStore')
class RedirectToTeam extends React.Component {
  constructor(props) {
    super(props);
    const {
      route: { name, params },
    } = routerStore;
    const { clientStore } = props;
    const tab = clientStore.isStaff ? 'admin' : 'teams';
    routerStore.navigate(`${name}.${tab}`, params, { replace: true });
  }

  render() {
    return null;
  }
}

RedirectToTeam.propTypes = {
  clientStore: PropTypes.object,
};

export const ProfileProjectSettingsRouter = routeNode(
  'profile.project.settings',
  viewsMap,
  RedirectToTeam,
)(ProjectSettings);

export const InitiativeProjectSettingsRouter = routeNode(
  'initiative.project.settings',
  viewsMap,
  RedirectToTeam,
)(ProjectSettings);
